export default __webpack_public_path__ + "static/media/image-3.b9f0c0ae.png";